import React from "react";
import cn from "classnames";
import styles from "./Advantages.module.sass";
import ScrollParallax from "../ScrollParallax";

const items = [
  {
    title: "Compounds yields automatically",
    image: "/images/content/hand-grip-circle.png",
    image2x: "/images/content/hand-grip-circle@2x.png"
  },
  {
    title: "Track your progress easily",
    image: "/images/content/gloves-circle.png",
    image2x: "/images/content/gloves-circle@2x.png"
  },
  {
    title: "Syncs with Apple Health and Google Fit",
    image: "/images/content/bottle-circle.png",
    image2x: "/images/content/bottle-circle@2x.png"
  }
];

const Advantages = () => {
  return (
    <div className={cn("section-bg", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.head}>
          <div className={cn("h2", styles.title)}>Earn in the Metaverse</div>
          <div className={styles.info}>
            Earn wherever you are and with your favorite apps: Peloton, Equinox,
            Basketball, Beat Saber, upcoming Metaverse games, etc. Wear your
            favorite tracker and connect Shibaboi's iOS or Android apps to earn
            additional SBOIs.
          </div>
        </div>
        <div className={styles.list}>
          {items.map((x, index) => (
            <ScrollParallax className={styles.item} key={index}>
              <div className={styles.preview}>
                <img srcSet={`${x.image2x} 2x`} src={x.image} alt="Equipment" />
              </div>
              <div className={styles.subtitle}>{x.title}</div>
            </ScrollParallax>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Advantages;
